import '../scss/app.scss';
import '../joint-state/js/components/navigation-main';
import '../joint-state/js/components/navigation-utility';
import '../joint-state/js/components/stickynav';
import '../joint-state/js/components/srriRatings';

if(typeof Site == "undefined"){
	window.Site = {};
}